/*@ngInject*/
const MyAuthorityModalController = function ($rootScope, $scope, localization, coreConstant, letterOfAuthorityForms, $uibModalInstance) {

    localization.getTranslationByKey('myAuthorityModal').then(function (translations) {
        $scope.title = _.get(translations, 'title');
        $scope.closeButton = _.get(translations, 'closeButton');

        $scope.letterOfAuthorityForms = letterOfAuthorityForms;
        $scope.selectedLetterOfAuthorityForm = letterOfAuthorityForms[0];
        $scope.formId = $scope.selectedLetterOfAuthorityForm.value;


        $scope.disableLetterOfAuthorityFormsDropdown = _.size($scope.letterOfAuthorityForms) === 1;

        $scope.handleSelect = function (selectedOption) {
            $scope.formId = selectedOption.value;
        };

        $scope.closePopUp = function () {
            $uibModalInstance.close();
        };
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('ums')
    .controller('myAuthorityModalController', MyAuthorityModalController);
